import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // Add Redux hooks
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select"
import { Line } from "react-chartjs-2";
import "react-tooltip/dist/react-tooltip.css";
import { useLocation } from "react-router-dom";
import { Tab, Nav, Button, Modal } from "react-bootstrap";
import "chart.js/auto";
import icon3 from "../../../../src/assets/images/medical-report.png"
import Prescription from "../Panchkarma/Components/PanchkarmaServiceCaller.component";
//import DiseaseHistory from "../AppsMenu/Patients/Components/DiseaseHistory";
import ServiceCallerFollowup from "../AppsMenu/Patients/Components/ServiceCallerFollowUp.Component";
import ServiceCallerNotes from "../AppsMenu/Patients/Components/ServiceCalllerNotes.Component";
import ServiceCallerFollowupReminder from "../AppsMenu/Patients/Components/ServiceCallerFollowupreminder.Component";
import { getPatientDetailsAction } from "../../../store/actions/ServiceCallerPrescriptionAction"; // Add your action import
import { PanchkarmaServiceCallerAppointmentCalendar } from "./Comman/PanchkarmaCoomanAppointmentCalender.example";
import WeightChart from "../AppsMenu/Patients/Components/WeightChart";
//Images
import defaultAvatar from "../../../../src/assets/images/avatar/patient_profile.png";
import icon from "../../../../src/assets/images/icons8-chart-48.png";
//import MenopauseChart from "../AppsMenu/Patients/Components/PatientMenopause.Component"
//import PatientGapld from "../AppsMenu/Patients/Components/PateintGapldServiceComponent"
import PatientMale from "../AppsMenu/Patients//Components/PatientMalechart.Component"

const therapistOptions = [
  { value: "Dr. Sharma", label: "Dr. Sharma" },
  { value: "Dr. Mehta", label: "Dr. Mehta" },
  { value: "Dr. Kulkarni", label: "Dr. Kulkarni" },
  { value: "Dr. Iyer", label: "Dr. Iyer" },
];
const initialEvents = [
  {
    title: "Booked",
    start: new Date("2025-02-15 10:00:00"),
    end: new Date("2025-02-15 11:00:00"),
    classNames: ["bg-red"],
  },
  {
    title: "Booked",
    start: new Date("2025-02-18 11:00:00"),
    end: new Date("2025-02-18 12:00:00"),
    classNames: ["bg-red"],
  },
  {
    title: "Booked",
    start: new Date("2025-01-20 12:00:00"),
    end: new Date("2025-01-20 13:00:00"),
    classNames: ["bg-red"],
  },
];

// LineChart1 component
const LineChart1 = ({ weightData }) => {
  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    datasets: [
      {
        label: "Weight Data",
        data: weightData,
        borderColor: "rgba(54,201,95,1)",
        borderWidth: 2,
        backgroundColor: "rgba(54,201,95, 0)",
        tension: 0.4,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          beginAtZero: true,
        },
      },
      x: {
        ticks: {
          padding: 5,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return <Line data={data} options={options} height={150} />;
};

const PanchkarmaViewDetails = () => {
  const location = useLocation();
  const { patientId, patientName, patientGender } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const patientDetails = useSelector(
    (state) => state.prescriptionState?.patientDetails
  );

  const [showNotesModal, setShowNotesModal] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [isImportant, setIsImportant] = useState(false);
  const [isEmergency, setIsEmergency] = useState(false);
  const [showFollowUpForm, setShowFollowUpForm] = useState(false);
  const [activeKey, setActiveKey] = useState("Prescriptions");
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [reminderDate, setReminderDate] = useState("");
  const [reminderTime, setReminderTime] = useState("");
  const [openPrescriptions, setOpenPrescriptions] = useState({});
  const [prescriptionExplained, setPrescriptionExplained] = useState({});
  const [medicineStarted, setMedicineStarted] = useState({});
  const [openPrescription, setOpenPrescription] = useState(null);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isDiseaseModalOpen, setIsDiseaseModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isFileInputDisabled, setIsFileInputDisabled] = useState(false);
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [bmi, setBmi] = useState("");
  const [systolicBP, setSystolicBP] = useState("");
  const [diastolicBP, setDiastolicBP] = useState("");
  const [pulseRate, setPulseRate] = useState("");
  const [temperature, setTemperature] = useState("");
  const [oxygenSaturation, setOxygenSaturation] = useState("");
  const [bloodGlucose, setBloodGlucose] = useState("");
  const [allergies, setAllergies] = useState("");
  const [reports, setReports] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isPersonalInfoModalOpen, setIsPersonalInfoModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [noteDescription, setNoteDescription] = useState("");
  const [calendarEvents, setCalendarEvents] = useState(initialEvents);
  const [noteType, setNoteType] = useState("self");
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [activeNote, setActiveNote] = useState(null);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showChart, setShowChart] = useState(false);
  const doctorIdFromUpcomingVisit =
    patientDetails?.upcomingVisits?.doctor_id || "";

  const [medicineDetails, setMedicineDetails] = useState({
    medicineName: "",
    medicineDose: "",
    frequency: "",
    weightOfDose: "",
    timePerDay: "",
    rateOfMedicine: "",
    anupaan: "",
  });

  const [lastNotes, setLastNotes] = useState("");
  const [selectedDiseases, setSelectedDiseases] = useState([]);
  const [prescriptions, setPrescriptions] = useState([]);
  const [followupList, setFollowupList] = useState([
    {
      prescriptionName: "Prescription ",
      date: "2025-06-28",
      time: "10:30",
      status: "Scheduled",
    },
    {
      prescriptionName: "Prescription ",
      date: "2025-06-30",
      time: "11:15",
      status: "Scheduled",
    },
  ]);

  // Initialize formData with default values
  const [formData, setFormData] = useState({
    patient_id: "",
    surname: "",
    firstName: "",
    husbandOrFatherName: "",
    dob1: "",
    age: "",
    whatsappNumber1: "",
    diseases: [],
    name: "",
    name1: "",
    Contact: "",
    email: "",
    profileImage: defaultAvatar,
    branch: "",
    additionalContact: "",
    dob: "",
    height: "",
    weight: "",
    occupation: "",
    married: false,
    spouseName: "",
    idProof: "",
    idNumber: "",
    deliveryOption: "",
    tempAddressLine1: "",
    tempAddressLine2: "",
    tempArea: "",
    tempCity: "",
    tempState: "",
    tempPincode: "",
    addressLine1: "",
    addressLine2: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    marriageHistory: "",
    marriageDate: "",
    currentDisease: [],
    diseaseStatus: "",
    spouseName1: "",
    spouseOption: "",
    profileImage1: defaultAvatar,
    gender: "",
    dateOfBirth: "",
    deliveryDate: "",
  });

  // Fetch patient details on component mount
  useEffect(() => {
    if (patientId) {
      dispatch(getPatientDetailsAction(patientId));
    }
  }, [dispatch, patientId]);

  // Update formData when patientDetails changes
  useEffect(() => {
    if (patientDetails) {
      const marriageInfo = patientDetails.marriageInfo?.[0] || {};
      const tempAddress = patientDetails.TemporaryAddress || {};
      const permanentAddress = patientDetails.PermanentAddress || {};

      // Calculate age from date of birth
      const calculateAge = (dob) => {
        if (!dob) return "";
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }
        return age.toString();
      };

      setFormData((prev) => ({
        ...prev,
        // Basic patient info
        firstName: patientDetails.first_name || "",
        surname: patientDetails.last_name || "",
        name: `${patientDetails.first_name || ""} ${patientDetails.middile_name || ""
          } ${patientDetails.last_name || ""}`.trim(),
        name1: `${patientDetails.first_name || ""} ${patientDetails.middile_name || ""
          } ${patientDetails.last_name || ""}`.trim(),
        email: patientDetails.patient_email || "",
        Contact: patientDetails.whatsapp_contact_no || "",
        additionalContact: patientDetails.additional_contact_no || "",
        gender: patientDetails.gender || "",
        dob: patientDetails.date_of_birth || "",
        dateOfBirth: patientDetails.date_of_birth || "",
        age: calculateAge(patientDetails.date_of_birth),
        height: patientDetails.height || "",
        weight: patientDetails.weight || "",
        occupation: patientDetails.occupation || "",
        idProof: patientDetails.id_proof || "",
        idNumber: patientDetails.id_number || "",
        profileImage1: patientDetails.patient_photo || defaultAvatar,

        // Marriage info
        marriageDate: marriageInfo.date_of_marriage || "",
        spouseName1: marriageInfo.husband_or_spouse_name || "",
        marriageHistory: marriageInfo.marriage_history || "",
        spouseOption: marriageInfo.spouse_option || "",

        // Address info
        tempAddressLine1: tempAddress.address_line1 || "",
        tempAddressLine2: tempAddress.address_line2 || "",
        tempArea: tempAddress.area || "",
        tempCity: tempAddress.city || "",
        tempState: tempAddress.state || "",
        tempPincode: tempAddress.pincode || "",

        addressLine1: permanentAddress.address_line1 || "",
        addressLine2: permanentAddress.address_line2 || "",
        area: permanentAddress.area || "",
        city: permanentAddress.city || "",
        state: permanentAddress.state || "",
        pincode: permanentAddress.pincode || "",
        country: permanentAddress.country || "",

        // Disease info - FIXED: Handle currentDiseases as object, not array
        currentDisease: patientDetails.currentDiseases?.disease_name
          ? [patientDetails.currentDiseases.disease_name]
          : [],
        diseases: patientDetails.diseases?.map((d) => d.disease_name) || [],
        diseaseStatus: patientDetails.currentDiseases?.disease_status || "",
      }));

      // Set weight and height for BMI calculation
      setWeight(patientDetails.weight || "");
      setHeight(patientDetails.height || "");
    }
  }, [patientDetails]);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Rest of your existing functions remain the same...
  const handleMarkAsDone = (index) => {
    Swal.fire({
      title: "Mark as Done?",
      text: "This follow-up will be marked as completed.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, mark as done",
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = [...followupList];
        updated[index].status = "Completed";
        setFollowupList(updated);
        Swal.fire(
          "Marked!",
          "The follow-up has been marked as completed.",
          "success"
        );
      }
    });
  };

  const handleCancel = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This follow-up reminder will be canceled.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedList = [...followupList];
        updatedList.splice(index, 1);
        setFollowupList(updatedList);
        Swal.fire(
          "Canceled!",
          "The follow-up reminder has been canceled.",
          "success"
        );
      }
    });
  };

  const handleEditProfileClick = () => {
    setIsProfileModalOpen(true);
  };

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const weightData = [49, 55, 57, 65, 66, 78, 82];

  const handleShowChart = () => {
    setShowChart(true);
  };

  const handleCloseChart = () => {
    setShowChart(false);
  };

  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const prescriptionData = [
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 12, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
  ];

  const handleViewClick = (prescription) => {
    setSelectedPrescription(prescription);
    setShowDetailModal(true);
  };

  const [modifiedPrescriptions, setModifiedPrescriptions] = useState([
    {
      medicineName: "Eladi Gaan kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "3",
      deliveredQuantity: "2",
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    // ... rest of your prescription data
  ]);

  const appointments = [
    {
      date: "07/04/2025",
      notes: [
        {
          title: "Questionnaire",
          content: [
            {
              question: "How are you feeling since your last visit?",
              answer: "Some symptoms have improved, but fatigue remains.",
            },
            // ... rest of questionnaire data
          ].map((qa, index) => (
            <div key={index} className="mb-2">
              <strong>
                Q{index + 1}: {qa.question}
              </strong>
              <p>A: {qa.answer}</p>
            </div>
          )),
        },
        // ... rest of notes
      ],
    },
    // ... rest of appointments
  ];

  const [filteredAppointments, setFilteredAppointments] = useState([
    ...appointments,
  ]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [sortDirection, setSortDirection] = useState("desc");

  const followupCallCount = appointments.filter((app) =>
    app.notes.some((note) => note.title.includes("Service Caller"))
  ).length;

  const prescription = 5;
  const questions = 3;

  const [data, setData] = useState({});
  const [doctorNoteCount, setDoctorNoteCount] = useState(0);
  const [telecallerNoteCount, setTelecallerNoteCount] = useState(0);

  // Rest of your useEffect and other functions remain the same...
  useEffect(() => {
    let filtered = [...appointments];
    if (activeFilter !== "All") {
      filtered = appointments.filter((appointment) => {
        return appointment.notes.some((note) => {
          const titleLower = note.title.toLowerCase();
          switch (activeFilter.toLowerCase()) {
            case "reports":
              return titleLower.includes("report");
            case "notes":
              return (
                titleLower === "notes" ||
                titleLower === "note" ||
                titleLower.includes("doctor note") ||
                titleLower.includes("telecaller note")
              );
            case "panchkarma":
              return titleLower.includes("panchakarma");
            case "counsellor":
              return titleLower.includes("counsellor");
            case "medical":
              return titleLower.includes("medical");
            default:
              return false;
          }
        });
      });

      filtered = filtered.map((appointment) => {
        const filteredAppointment = { ...appointment };
        filteredAppointment.notes = appointment.notes.filter((note) => {
          const titleLower = note.title.toLowerCase();
          switch (activeFilter.toLowerCase()) {
            case "reports":
              return titleLower.includes("report");
            case "notes":
              return (
                titleLower === "notes" ||
                titleLower === "note" ||
                titleLower.includes("doctor note") ||
                titleLower.includes("telecaller note")
              );
            case "panchkarma":
              return titleLower.includes("panchakarma");
            case "counsellor":
              return titleLower.includes("counsellor");
            case "medical":
              return titleLower.includes("medical");
            default:
              return false;
          }
        });
        return filteredAppointment;
      });
    }

    filtered.sort((a, b) => {
      const dateA = new Date(a.date.split("/").reverse().join("-"));
      const dateB = new Date(b.date.split("/").reverse().join("-"));
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
    });

    setFilteredAppointments(filtered);
  }, [activeFilter, sortDirection]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newPrescription, setNewPrescription] = useState({
    medicineName: "",
    dose: "",
    frequency: "",
    quantity: "",
    howToTake: "",
  });

  // All your other existing functions remain the same...
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPrescription({ ...newPrescription, [name]: value });
  };

  const handleInputonChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOnSubmit = () => {
    setPrescriptions([...prescriptions, newPrescription]);
    setNewPrescription({
      medicineName: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
    });
    setIsModalOpen(false);
  };

  const handleGeneratePrescription = () => {
    ("Prescription generated!");
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGenderChange = (selectedOption) => {
    setFormData({ ...formData, gender: selectedOption.value });
  };

  const handleMarriageHistoryChange = (selectedOption) => {
    setFormData({ ...formData, marriageHistory: selectedOption.value });
  };

  const handleCurrentDiseaseChange = (selectedOption) => {
    setFormData({ ...formData, currentDisease: selectedOption.value });
  };

  const handleStatusChange = (selectedOption) => {
    setFormData({ ...formData, diseaseStatus: selectedOption.value });
  };

  const handleSpouseOptionChange = (e) => {
    setFormData({ ...formData, spouseOption: e.target.value });
  };

  const handleINChange = (group, index, value) => {
    setData((prevData) => {
      const updatedData = { ...prevData };
      updatedData[group][index] = value;
      return updatedData;
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log({
      patientName,
      medicineDetails,
      lastNotes,
      selectedDiseases: selectedDiseases.map((option) => option.value),
    });
  };

  const diseaseOptions = [
    { value: "diabetes", label: "Diabetes" },
    { value: "sleepProblem", label: "Sleep Problem" },
    { value: "dentalCare", label: "Dental Care" },
    { value: "hypertension", label: "Hypertension" },
  ];

  const handleSubmitDiseases = (e) => {
    e.preventDefault();
    console.log("Diseases Data:", formData.diseases);
    setIsDiseaseModalOpen(false);
  };

  const handleEditDiseaseClick = () => {
    setIsDiseaseModalOpen(true);
  };

  const calculateBMI = (w, h) => {
    if (w > 0 && h > 0) {
      setBmi((w / (h * h)) * 10000);
    } else {
      setBmi("");
    }
  };

  const handleWeightChange = (e) => {
    const w = e.target.value;
    setWeight(w);
    calculateBMI(w, height);
  };

  const handleHeightChange = (e) => {
    const h = e.target.value;
    setHeight(h);
    calculateBMI(weight, h);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      systolicBP,
      diastolicBP,
      weight,
      height,
      bmi,
      pulseRate,
      temperature,
      oxygenSaturation,
      bloodGlucose,
      allergies,
      reports,
    });
  };

  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setNoteDescription("");
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setUploadedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleView = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  };

  const handleDelete = (index) => {
    setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const roleOptions = [
    { value: "counselor", label: "Counselor" },
    { value: "medical", label: "Medical" },
  ];

  const handleInChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleinSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  const handleAddNote = () => {
    const newNote = {
      description: noteDescription,
      type: noteType,
      roles: selectedRoles.map((role) => role.value),
    };
    console.log("Note Type:", noteType);
    console.log("Selected Roles:", selectedRoles);
    console.log("New Note:", newNote);
    setNoteDescription("");
    setNoteType("self");
    setSelectedRoles([]);
    handleClose();
  };

  const handleDeliveryOptionChange = (selectedOption) => {
    setFormData({ ...formData, deliveryOption: selectedOption.value });
  };

  const handleComplete = (index) => {
    const updated = [...followupList];
    updated[index].status = "Completed";
    setFollowupList(updated);
    Swal.fire({
      title: "Completed!",
      text: "Task has been marked as complete.",
      icon: "success",
      confirmButtonText: "Done",
      confirmButtonColor: "#198754",
    });
  };

  const targetDate = "08/04/2025";
  const appointmentsOnDate = filteredAppointments.filter(
    (appointment) => appointment.date === targetDate
  );

  const togglePrescription = (index, noteIndex) => {
    const key = `${index}-${noteIndex}`;
    setOpenPrescriptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };



  const handleSaveReminder = () => {
    console.log("Save reminder called with:", { reminderDate, reminderTime });
    if (!reminderDate || !reminderTime) {
      Swal.fire({
        title: "Missing Information",
        text: "Please select both date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const selectedDateTime = new Date(`${reminderDate}T${reminderTime}`);
    const now = new Date();
    if (selectedDateTime <= now) {
      Swal.fire({
        title: "Invalid Date/Time",
        text: "Please select a future date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const newReminder = {
      prescriptionName: "Prescription Reminder",
      date: reminderDate,
      time: reminderTime,
      status: "Scheduled",
      createdAt: new Date().toISOString(),
    };

    setFollowupList((prev) => [...prev, newReminder]);
    console.log("Reminder saved successfully:", newReminder);

    setReminderDate("");
    setReminderTime("");
    setShowReminderModal(false);

    Swal.fire({
      title: "Success!",
      text: `Follow-up reminder has been scheduled for ${new Date(
        selectedDateTime
      ).toLocaleString()}.`,
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  const handleSaveNote = () => {
    console.log("Note:", noteText);
    console.log("Important:", isImportant);
    console.log("Emergency:", isEmergency);
    setShowNotesModal(false);
  };

  return (
    <>
      <div className="d-flex justify-content-end mb-4">
        <Button variant="primary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      {/* <div className="container-fluid" style={{ padding: "20px" }}> */}
      <div className="row">
        {/* LEFT SIDE - PROFILE CARD */}
        <div className="col-xl-4">
          <div className="card" >
            <div className="card-body pt-4">
              <div className="media d-sm-flex d-block text-center text-sm-start pb-4 mb-4 border-bottom">
                <img
                  alt=""
                  className="rounded me-sm-4 me-0"
                  width={100}
                  src={formData.profileImage1 || "/placeholder.svg"}
                />
                <div className="media-body align-items-center">
                  <div className="d-sm-flex d-block justify-content-between my-3 my-sm-0">
                    <div>
                      <h3 className="fs-22 text-black font-w600 mb-3">
                        {formData.name1}
                      </h3>
                    </div>
                    <span className="me-3 d-inline-flex align-items-center">
                      <Link
                        to={`/case-paper/${patientDetails?.patient_id || patientDetails?.id
                          }`}
                        title="Case Paper"
                      >
                        <img
                          src={icon3 || "/placeholder.svg"}
                          alt="Case Paper"
                          width={28}
                          height={28}
                          style={{ cursor: "pointer" }}
                        />
                      </Link>

                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <Link
                      to="#"
                      className="btn bgl-primary btn-rounded text-black me-2"
                    >
                      {formData.gender === "Male" && (
                        <>
                          <svg
                            className="me-2 scale5"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 2H22V10H20V5.41L15.71 9.71C16.45 10.79 16.91 12.1 16.98 13.5C17.17 17.14 14.32 20.24 10.68 20.48C6.79 20.74 3.5 17.6 3.5 13.71C3.5 9.82 6.65 6.53 10.54 6.29C11.94 6.2 13.25 6.66 14.34 7.41L18.59 3H14V2Z"
                              fill="#2BC155"
                            />
                          </svg>
                          Male
                        </>
                      )}
                      {formData.gender === "Female" && (
                        <>
                          <svg
                            className="me-2 scale5"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2C8.13 2 5 5.13 5 9C5 12.52 7.61 15.44 11 15.93V18H8V20H11V22H13V20H16V18H13V15.93C16.39 15.44 19 12.52 19 9C19 5.13 15.87 2 12 2ZM12 13C9.24 13 7 10.76 7 8C7 5.24 9.24 3 12 3C14.76 3 17 5.24 17 8C17 10.76 14.76 13 12 13Z"
                              fill="#C92A2A"
                            />
                          </svg>
                          Female
                        </>
                      )}
                      {!formData.gender && <span> Male </span>}
                    </Link>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="row mb-2">
                  <div className="col-4">
                    <h5 className="f-w-500">Husband / Wife Name:</h5>
                    <span>{formData.spouseName1 || "Suhani"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">Age:</h5>
                    <span>{formData.age}  40</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500" style={{ whiteSpace: "nowrap" }}>
                      Occupation:
                    </h5>

                    <span>{formData.occupation || "Actor"}</span>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-4">
                    <h5 className="f-w-500">Weight: (kg)</h5>
                    <span>{formData.weight || "75"} </span>
                    <img
                      src={icon || "/placeholder.svg"}
                      alt="History Icon"
                      onClick={handleShowChart}
                      style={{
                        cursor: "pointer",
                        marginLeft: "8px",
                        width: "24px",
                        height: "24px",
                      }}
                    />
                  </div>

                  {/* Weight Chart Component */}
                  <WeightChart
                    patientId={patientId}
                    show={showChart}
                    onClose={handleCloseChart}
                    height={formData.height}
                    gender={formData.gender}
                  />

                  <div className="col-4">
                    <h5 className="f-w-500">Marriage History:</h5>
                    <span>{formData.marriageHistory || "1"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">Marriage Date:</h5>
                    <span>{formData.marriageDate || "02-02-2013"}</span>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-4">
                    <h5 className="f-w-500">Current Disease:</h5>
                    <span>{formData.currentDisease.join(", ") || "None"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">Status:</h5>
                    <span>{formData.diseaseStatus || "Active"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">With Spouse:</h5>
                    <span>
                      {formData.spouseOption === "withSpouse" ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-8">
          <div className="card" style={{ width: "100%" }}>
            <div className="card-body">
              <div className="profile-tab">
                <div className="custom-tab-1">
                  <Tab.Container
                    activeKey={activeKey}
                    onSelect={(k) => setActiveKey(k)}
                  >
                    <Nav
                      as="ul"
                      className="nav nav-tabs flex-nowrap overflow-auto"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link eventKey="Prescriptions">
                          Follow-Up
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link eventKey="Followup-Remider">
                          Follow-Up Remider
                        </Nav.Link>
                      </Nav.Item>
                      {/* <Nav.Item as="li" className="nav-item">
                            <Nav.Link eventKey="Diseases">
                              Diseases History
                            </Nav.Link>
                          </Nav.Item> */}
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link eventKey="Notes">Notes</Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link eventKey="Appointments">
                          Appointment
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link eventKey="Panchkarma">
                          Panchkarma
                        </Nav.Link>
                      </Nav.Item>
                      {formData.gender === "Female" && (
                        <>
                          {/* <Nav.Item as="li" className="nav-item">
                                  <Nav.Link eventKey="Menopause">
                                    Menopause
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="nav-item">
                                  <Nav.Link eventKey="GAPLD">GAPLD</Nav.Link>
                                </Nav.Item> */}
                        </>
                      )}

                      {formData.gender === "Male" && (
                        <Nav.Item as="li" className="nav-item">
                          <Nav.Link eventKey="Malechart">
                            Male Chart
                          </Nav.Link>
                        </Nav.Item>
                      )}
                    </Nav>

                    <Tab.Content>
                      {/* <Tab.Pane eventKey="GAPLD">
                        <PatientGapld patientId={patientId} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Menopause">
                            <MenopauseChart></MenopauseChart>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Malechart">
                            <PatientMale></PatientMale>
                          </Tab.Pane> */}
                      <Tab.Pane eventKey="Followups">
                        <ServiceCallerFollowup />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Followup-Remider">
                        <ServiceCallerFollowupReminder />
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="Diseases">
                            <DiseaseHistory patientId={patientId} />
                          </Tab.Pane> */}

                      <Tab.Pane eventKey="Prescriptions">
                        <Prescription
                          // patientId={patientId}
                          // patientName={patientName}
                          // patientGender={patientGender}
                          setActiveKey={setActiveKey}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Notes">
                        <ServiceCallerNotes
                          defaultDoctorId={"1"}
                          patientId={patientId}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Appointments">
                        <PanchkarmaServiceCallerAppointmentCalendar
                          patientId={patientId}
                          leadId={undefined} // Using patientId as leadId since this is a converted patient
                          doctorId={doctorIdFromUpcomingVisit} // Will be selected in the calendar component
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Panchkarma">
                        <div className="card shadow-none">
                          <div className="card-body">
                            <div
                              style={{ height: "370px" }}
                              id="DZ_W_TimeLine"
                              className="widget-timeline dz-scroll height370"
                            >
                              <ul className="timeline">
                                <li>
                                  <div className="timeline-badge success"></div>
                                  <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                    <span>
                                      Date: <strong>Jan 18, 2025</strong>
                                    </span>
                                    <h6 className="mb-0">
                                      Doctor: Dr. Mehta <strong className="text-success">Ongoing</strong>
                                    </h6>
                                  </Link>
                                </li>
                                <li>
                                  <div className="timeline-badge warning"></div>
                                  <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                    <span>
                                      Date: <strong>Jan 18, 2025</strong>
                                    </span>
                                    <h6 className="mb-0">
                                      Doctor: Dr. Mehta <strong className="text-warning">Scheduled</strong>
                                    </h6>
                                  </Link>
                                </li>
                                <li>
                                  <div className="timeline-badge danger"></div>
                                  <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                    <span>
                                      Date: <strong>Jan 18, 2025</strong>
                                    </span>
                                    <h6 className="mb-0">
                                      Doctor: Dr. Mehta <strong className="text-danger">Pending</strong>
                                    </h6>
                                  </Link>
                                </li>
                                <li>
                                  <div className="timeline-badge primary"></div>
                                  <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                    <span>
                                      Date: <strong>Jan 18, 2025</strong>
                                    </span>
                                    <h6 className="mb-0">
                                      Doctor: Dr. Mehta <strong className="text-primary">Completed</strong>
                                    </h6>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default PanchkarmaViewDetails;
